import { useCallback, useState } from 'react';

import { FilterOperators } from '@/components/Filter/types';
import useListActions from '@/hooks/useList/useListActions';

import { OPERATORS_WITHOUT_OPTION_LIST } from '../components/Body';
import { NewFilterOption, UseFilterListActionsProps } from '../types';

export default function useFilterListActions({
  initialSelectedOptions,
  keyExtractor,
  showActionButtons,
  onChange,
  initialSelectedOperator,
}: UseFilterListActionsProps) {
  const [currSelectedOperator, _setSelectedOperator] = useState<FilterOperators | undefined>(
    initialSelectedOperator,
  );

  const onFilterChange = useCallback(
    (val: NewFilterOption[]) => {
      onChange?.(val, currSelectedOperator);
    },
    [onChange, currSelectedOperator],
  );

  const [
    selectedOptions,
    { toggle: toggleOption, addMultiple, removeMultiple, removeAll, addSingle },
  ] = useListActions({
    selectedItems: initialSelectedOptions,
    keyExtractor,
    updateOnAction: !showActionButtons,
    onChange: onFilterChange,
  });

  const setSelectedOperator = useCallback(
    (operator: FilterOperators | undefined) => {
      _setSelectedOperator(operator);
      if (operator && OPERATORS_WITHOUT_OPTION_LIST.includes(operator.id)) {
        removeAll();
      }
    },
    [removeAll],
  );

  return {
    operatorsActions: {
      selectedOperator: currSelectedOperator,
      methods: {
        setSelectedOperator,
      },
    },
    optionsActions: {
      selectedOptions,
      methods: {
        toggleOption,
        addMultiple,
        removeMultiple,
        removeAll,
        addSingle,
      },
    },
  };
}
